@import './commonstyle.module';

.page {
  text-align: left;

  @include target(tablet) {
    .description {
      display: inline-flex;
      text-align: center;
    }
  }

  p {
    + p {
      margin-top: 1rem;
    }
  }

  .buttonContainer + .buttonContainer {
    margin-left: 0.625rem;
  }

  .infoLoggedOut {
    background-color: white;
    border: 0.0625rem solid black;
    border-radius: 5px;
    color: #700;
    display: block;
    font-size: 1.25rem;
    font-weight: bold;
    margin: 0 2.5rem 2.5rem;
    padding: 0.625rem;
  }

  .smallPage {
    text-align: center;

    .infoLoggedOut {
      line-height: 2.25rem;
      margin-top: 6.9rem;
      padding: 0.75rem 0.625rem;
    }
  }

  .loginBtnContainer {
    display: flex;
    width: fit-content;

    .btnWithHelpText {
      display: flex;
      flex-direction: column;
      width: 15em;

      &:last-child {
        margin-left: 2em;
      }

      .helpText {
        margin-top: 0.5em;
      }
    }
  }
}
